export default __webpack_public_path__ + "static/strategy-4828c83c880d00fc30e24eb032aa34c8.jpg";